module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "align": "left"
    }
  }, [(!_vm.hidePanel) ? _c('edit-pane', {
    ref: "sra",
    attrs: {
      "prefix": "Contractor: ",
      "title": _vm.form.summary,
      "table-ref": "site-contractors-table",
      "edit-mode": _vm.editMode
    },
    on: {
      "cancel": _vm.onCancel,
      "save": _vm.onSave,
      "edit": _vm.onEdit
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form', {
    attrs: {
      "model": _vm.form,
      "inline": _vm.adding ? true : false,
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('select-contractor', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.contractor_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "contractor_id", $$v)
      },
      expression: "form.contractor_id"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('select-contractor-sub-category', {
    attrs: {
      "label": "Type",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Summary",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.summary),
      callback: function($$v) {
        _vm.$set(_vm.form, "summary", $$v)
      },
      expression: "form.summary"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Inv. No.",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.invoiceNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "invoiceNo", $$v)
      },
      expression: "form.invoiceNo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.form.started || !_vm.disabled) ? _c('date-time-input', {
    attrs: {
      "label": "Started",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.started),
      callback: function($$v) {
        _vm.$set(_vm.form, "started", $$v)
      },
      expression: "form.started"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.form.ended || !_vm.disabled) ? _c('date-time-input', {
    attrs: {
      "label": "Ended",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.ended),
      callback: function($$v) {
        _vm.$set(_vm.form, "ended", $$v)
      },
      expression: "form.ended"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [(_vm.form.amount || !_vm.disabled) ? _c('currency-input', {
    attrs: {
      "label": "Amount",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.amount),
      callback: function($$v) {
        _vm.$set(_vm.form, "amount", $$v)
      },
      expression: "form.amount"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('check-box', {
    attrs: {
      "label": "Taxable?",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.isTaxable),
      callback: function($$v) {
        _vm.$set(_vm.form, "isTaxable", $$v)
      },
      expression: "form.isTaxable"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [(_vm.form.isTaxable) ? _c('el-form-item', {
    attrs: {
      "label": _vm.taxLabel ? _vm.taxLabel : 'Tax'
    }
  }, [_c('b', [_vm._v(_vm._s(this.formatNumber(this.taxes, 2)))])]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [(_vm.form.isTaxable) ? _c('el-form-item', {
    attrs: {
      "label": "Total"
    }
  }, [_c('b', [_vm._v(_vm._s(this.formatNumber(this.totals, 2)))])]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.adding) ? _c('files-panel', {
    attrs: {
      "title": "Contractor Attachments",
      "type": "site",
      "id": _vm.form.site_id,
      "process": "contractor",
      "process-id": _vm.form.id,
      "max-files": 3,
      "disabled": !_vm.isManager('finance|management')
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17f594a9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/finance/contractors/SiteContractorsDetails.vue
// module id = 1346
// module chunks = 0